export default __webpack_public_path__ + "static/media/testimonial-1.cd17de1e.png";